/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import ResourceCircle from 'icons/resourceCircle/resourceCircle';
import Elipsis from 'icons/elipsis';
import Bubble from 'components/bubble/bubble';
import style from './contextActions.module.scss';
import map from 'lodash-es/map';
import { PossibleAction } from 'store/types';
import ActionComponent from './action/action';
import cx from 'classnames';
import ExpandArrowIcon from 'icons/expandArrow';
import CartineIcon from 'icons/cartine';
import BigElipsis from 'icons/bigElipsis';
import { CSSTransition } from 'react-transition-group';
import { DURATIONS } from 'utils/utils';

export type ContextActionHandler = () => void;

export type ContextAction = {
  type: PossibleAction;
  handler?: ContextActionHandler;
};

export type ContextActions = ContextAction[];
type ContextActionsProps = {
  actions: ContextAction[];
  iconType?: 'content' | 'tags' | 'navigation' | 'cartine';
  className?: string;
  iconClassName?: string;
  bubbleClassName?: string;
  resourceCircleClassName?: string;
};

export default React.forwardRef<HTMLDivElement, ContextActionsProps>(
  (
    {
      actions,
      iconType = 'content',
      className,
      iconClassName,
      bubbleClassName,
      resourceCircleClassName,
    },
    ref
  ) => {
    const [isVisible, setIsVisible] = useState(false);

    const listener = () => {
      setIsVisible(false);
      document.removeEventListener('click', listener);
    };

    const onClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setIsVisible(!isVisible);

      if (isVisible) {
        return;
      }
      setTimeout(() => document.addEventListener('click', listener), 1);
    };

    return (
      <div className={cx(style.container, className)}>
        {iconType === 'content' && (
          <ResourceCircle className={resourceCircleClassName}>
            <div ref={ref} className={style.flex} onClick={onClick}>
              <BigElipsis className={cx(style.elipsis, iconClassName)} />
            </div>
          </ResourceCircle>
        )}

        {iconType === 'tags' && (
          <div ref={ref} className={style.flex} onClick={onClick}>
            <Elipsis
              className={cx(style.elipsis, style.vertical, iconClassName)}
            />
          </div>
        )}

        {iconType === 'navigation' && (
          <div ref={ref} className={style.flex} onClick={onClick}>
            <ExpandArrowIcon
              className={cx(style.expand, iconClassName)}
            ></ExpandArrowIcon>
          </div>
        )}

        {iconType === 'cartine' && (
          <div ref={ref} className={style.flex} onClick={onClick}>
            <CartineIcon
              className={cx(style.expand, iconClassName)}
            ></CartineIcon>
          </div>
        )}

        <CSSTransition
          in={isVisible}
          timeout={DURATIONS.BUBBLE_TOGGLE}
          classNames="bubble-tg"
        >
          <Bubble
            className={cx(style.bubble, bubbleClassName)}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              document.getElementById('root')?.click();
            }}
          >
            {map(actions, (action) => {
              return (
                <ActionComponent
                  action={action}
                  key={action.type}
                ></ActionComponent>
              );
            })}
          </Bubble>
        </CSSTransition>

        {/* {isVisible && (
          <Bubble
            className={cx(style.bubble, bubbleClassName)}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              document.getElementById('root')?.click();
            }}
          >
            {map(actions, (action) => {
              return (
                <ActionComponent
                  action={action}
                  key={action.type}
                ></ActionComponent>
              );
            })}
          </Bubble>
        )} */}
      </div>
    );
  }
);
